import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Routines } from './components/routines';
import { RoutinesFilterPage } from './components/routinesFilterPage';
import { RoutinesToolbar } from './components/routinesToolbar';
import { routinesPaths } from './routinesPaths';

export const newRoutinesRoutes = [
  {
    path: `${routinesPaths.root}/filters`,
    element: <RoutinesFilterPage />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.routinespage.read,
    },
  },
  {
    path: `${routinesPaths.root}/*`,
    element: <Routines />,
    handle: {
      header: {
        titleKey: 'assets.list.routines',
        icon: 'format-list-checks',
      },
      requiredPermission: Permissions.routinespage.read,
      toolbar: <RoutinesToolbar />,
    },
    children: [],
  },
];
